// ================================================================================
// Custom events
//
// To help make it easier to add custom functionality, the theme emits custom
// events (along with their associated data) related to key theme features.
//
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// ================================================================================

/* eslint-disable no-console */

// ================================================================================
// "Item added to the cart"
//
// - Fires whenever an item has been added to the cart
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The associated product object
// ================================================================================
document.addEventListener("cart:item-added", function (evt) {
});

// ================================================================================
// "Cart updated"
//
// - Fires whenever the cart is updated
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("cart:updated", function (evt) {
});

// ================================================================================
// "Cart error"
//
// - Fires whenever there is an error when adding an item to the cart
//   - Typically due to a product not having sufficient stock
// - "detail" object data:
//   - The error message
// ================================================================================
document.addEventListener("cart:error", function (evt) {
});

// ================================================================================
// "Quick cart opened"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
document.addEventListener("quick-cart:open", function (evt) {
});

// ================================================================================
// "Quick cart closed"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// ================================================================================
document.addEventListener("quick-cart:close", function () {
});

// ================================================================================
// "Product variant changed"
//
// - Fires whenever a variant product is selected
// - Exposed when a 'Variant selectors' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
// ================================================================================
document.addEventListener("product:variant-change", function (evt) {
  // Update ingredients accordion with variant-specific ingredients
  const variant = evt.detail.variant;
  if (variant && variant.id) {
    const ingredientsAccordions = document.querySelectorAll('[data-ingredients-accordion="true"]');
    ingredientsAccordions.forEach(function(accordion) {
      // Get the ingredients data for this accordion
      const ingredientsJson = accordion.querySelector('[data-variant-ingredients-json]');
      if (ingredientsJson) {
        try {
          const ingredientsData = JSON.parse(ingredientsJson.textContent);
          const variantIngredients = ingredientsData[variant.id];
          
          let contentElement = accordion.querySelector('p');
          const topParent = contentElement.closest('.accordion');
          if (!contentElement) {
            contentElement = document.createElement('p');
            accordion.appendChild(contentElement);
          }
          
          if (variantIngredients && variantIngredients !== 'null') {
            contentElement.textContent = variantIngredients;
            topParent.style.display = 'block';
          } else {
            contentElement.textContent = '';
            topParent.style.display = 'none';

          }
        } catch (e) {
          console.error('Error parsing ingredients data:', e);
        }
      }
    });
  }
});

// ================================================================================
// "Product quantity updated"
//
// - Fires whenever a product quanatiy is updated
// - Exposed when a 'Quantity selector' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
//   - The quantity
// ================================================================================
document.addEventListener("product:quantity-update", function (evt) {
});

// ================================================================================
// "Quick view loaded"
//
// - Fires whenever a quick view modal is opened
// - Exposed when the 'Enable quick view' setting is enabled and a quick view
//   modal is opened
// ================================================================================
document.addEventListener("quick-view:loaded", function () {
});
/* eslint-enable no-console */
